import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "colin_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const http = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

http.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// public
export const getArtworks = (params = {}) => http.get("/artworks", { params }).then((r) => r.data);
export const getArtwork = (id) => http.get(`/artworks/${id}`).then((r) => r.data);
export const getPress = (verifiedOnly = true) =>
  http.get("/press", { params: { verified_only: verifiedOnly } }).then((r) => r.data);
export const getStats = () => http.get("/stats").then((r) => r.data);
export const postCommission = (payload) => http.post("/commissions", payload).then((r) => r.data);
export const postContact = (payload) => http.post("/contact", payload).then((r) => r.data);
export const postNewsletter = (email) => http.post("/newsletter", { email }).then((r) => r.data);

// auth
export const requestMagicLink = (email) =>
  http.post("/auth/request-link", { email }).then((r) => r.data);
export const verifyMagicToken = (token) =>
  http.post("/auth/verify", { token }).then((r) => r.data);
export const getMe = () => http.get("/auth/me").then((r) => r.data);

// admin
export const adminListArtworks = () => http.get("/admin/artworks").then((r) => r.data);
export const adminCreateArtwork = (payload) =>
  http.post("/admin/artworks", payload).then((r) => r.data);
export const adminUpdateArtwork = (id, payload) =>
  http.put(`/admin/artworks/${id}`, payload).then((r) => r.data);
export const adminDeleteArtwork = (id) =>
  http.delete(`/admin/artworks/${id}`).then((r) => r.data);

export const adminListPress = () => http.get("/admin/press").then((r) => r.data);
export const adminCreatePress = (payload) => http.post("/admin/press", payload).then((r) => r.data);
export const adminUpdatePress = (id, payload) =>
  http.put(`/admin/press/${id}`, payload).then((r) => r.data);
export const adminDeletePress = (id) =>
  http.delete(`/admin/press/${id}`).then((r) => r.data);
